<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useRouter, useRoute } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store.js';
import Button from 'dashboard/components-next/button/Button.vue';
import PageLayout from 'dashboard/components-next/metaAgent/PageLayout.vue';

const { t } = useI18n();
const store = useStore();
const router = useRouter();
const route = useRoute();

const uiFlags = useMapGetter('metaAgent/getUIFlags');
const isFetching = computed(() => uiFlags.value.fetchingInboxes);

const goToInboxes = () => {
  router.push({
    name: 'settings_inbox_new',
    params: { accountId: route.params.accountId, page: 'new' },
  });
};

onMounted(() => store.dispatch('metaAgent/getInboxes'));
</script>

<template>
  <PageLayout :is-fetching="isFetching">
    <div class="flex flex-col items-center justify-center h-full gap-4 py-16">
      <span class="i-lucide-message-square-plus size-10 text-n-slate-10" />
      <h2 class="text-lg font-medium text-n-slate-12">
        {{ t('META_AGENT.EMPTY_STATE.TITLE') }}
      </h2>
      <p class="max-w-md text-sm text-center text-n-slate-11">
        {{ t('META_AGENT.EMPTY_STATE.DESCRIPTION') }}
      </p>
      <Button
        :label="t('META_AGENT.EMPTY_STATE.TITLE')"
        icon="i-lucide-plus"
        size="sm"
        @click="goToInboxes"
      />
    </div>
  </PageLayout>
</template>
